/**
 *  Exports a class which can be instantiated to create a new page containing a preact
 *  component.
 */
import * as preact from "preact";

interface PreactPageOptions {
  name: string;
  showHeader: boolean;
  Child: preact.ComponentClass<{
    appRouter: any;
    options?: object;
  }>;
}

export default class PreactPage {
  name: string;
  showHeader: boolean;
  Child: preact.ComponentClass<{
    appRouter: any;
    options?: object;
  }>;
  containerElement: HTMLElement | undefined;

  constructor(options: PreactPageOptions) {
    this.name = options.name;
    this.showHeader = options.showHeader;
    this.Child = options.Child;
  }

  async render(element, renderedCallback, appRouter, options) {
    element.empty();
    preact.render(
      <this.Child appRouter={appRouter} options={options} />,
      element[0]
    );
    this.containerElement = element[0];
    renderedCallback();
  }

  close() {
    if (this.containerElement === undefined) {
      return;
    }
    // Render an empty div to force unmounting of the component
    preact.render(null, this.containerElement);
    this.containerElement = undefined;
  }
}
